import React from "react";

import { Container } from "@components/Container/Container";

import styles from "./styles.module.scss";
import stylesHeading from "@components/Heading/styles.module.scss";
import { Box } from "@components/Box/Box";
import classnames from "classnames";
import Anime from "react-anime";
import { animeChildrenProps } from "@helpers/animations";
import { useInView } from "react-intersection-observer";
import { Heading } from "@components/Heading/Heading";
import { ContactBox, ContactBoxProps } from "@components/ContactBox/ContactBox";
export interface ContactsProps {
  contacts: ContactBoxProps[];
  headline?: string;
  showInfo?: boolean;
  aspectRatio?: string;
}

const Contact: React.FC<ContactsProps> = ({
  contacts,
  headline,
  showInfo,
  aspectRatio,
  ...props
}) => {
  const { ref, inView } = useInView({
    threshold: 0.2
  });
  
  return (
    <div
      ref={ref}
      className={classnames(styles.Contact, styles.ContactfocusGrid)}
      {...props}
    >
      <Container>
        {headline && (
          <Heading as="h2" className={stylesHeading.headingRibbon}>
            {headline}
          </Heading>
        )}
        <Box className={styles.gridFour}>
          {contacts &&
            contacts.map((contact: ContactBoxProps, index: number) => {
              const animateEachChild = {
                ...animeChildrenProps,
                ...{ delay: (index * 100) / 1.5 },
                ...(inView ? { autoplay: true } : { autoplay: false })
              };
              return (
                <Anime {...animateEachChild} key={contact.Key}>
                  <ContactBox
                    Image={contact.Image}
                    Title={contact.Title}
                    FullName={contact.FullName}
                    Description={contact.Description}
                    Email={contact.Email}
                    Phone={contact.Phone}
                    ShowInfo={showInfo}
                    format={aspectRatio==="Brug 4:5 Format" ? "4:5" : "1:1"}
                  />
                </Anime>
              );
            })}
        </Box>
      </Container>
    </div>
  );
};

export { Contact };
